module.exports = {
    SIGNUPVALIDATION_FAIL: 'SIGNUPVALIDATION_FAIL',
    SIGNUPVALIDATION_SUCCESS: 'SIGNUPVALIDATION_SUCCESS'
}



// WEBPACK FOOTER //
// ./src/signup/constants/SignUpValidationConstants.js